import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';
import uniqWith from 'lodash/uniqWith';
import { defaultColorById } from 'src/common/utils';
import { IresourceProject } from 'src/interface/IHeatmapState';

type IObjectMap = {
  [key: number]: string | number;
};

export const getProjectList = (data: IresourceProject[]) => {
  const listProject: string[] = [];
  const colorProject: IObjectMap = {};
  const idProject: IObjectMap = {};
  const fullNameProject: IObjectMap = {};
  if (data && data.length) {
    data.forEach((element) => {
      const projectId = String(element.project.id);
      if (!listProject.includes(projectId)) {
        listProject.push(projectId);
      }
      colorProject[element.project.id] =
        element.project.color || defaultColorById(element.project.id);
      idProject[element.project.id] = element.project.id;
      fullNameProject[element.project.id] = element.project.name;
    });
  }
  return {
    listProject,
    colorProject,
    idProject,
    fullnameProject: fullNameProject
  };
};

const createListArrayDate = (timeStart: string, timeEnd: string, dataFilter: Array<any>) => {
  let timeFirst = dayjs(timeStart);
  const timeSecond = dayjs(timeEnd);
  const Arr: Array<string> = [];
  const finalData: Array<any> = [];
  if (timeStart && timeEnd) {
    do {
      Arr.push(dayjs(timeFirst).format('MM/DD/YYYY'));
      timeFirst = dayjs(timeFirst).add(1, 'days');
    } while (timeFirst <= timeSecond);
    Arr.forEach((item) => {
      const itemFilter = dataFilter.find((value) => {
        return dayjs(value.day).format('MM/DD/YYYY') === item;
      });
      if (itemFilter) {
        itemFilter.day = dayjs(itemFilter.day).format('MM/DD/YYYY');
        finalData.push(itemFilter);
      } else {
        const date = dayjs(item, 'MM/DD/YYYY').format('DD');
        finalData.push({ day: item, date: date });
      }
    });
  }
  return finalData;
};

export const handleDataResource = (
  data: IresourceProject[],
  timeStart: string,
  timeEnd: string
) => {
  const resultItem = {};
  const resultData: Array<Record<string, any>> = [];
  if (data && data.length) {
    data.forEach((item: any) => {
      const current = resultItem[item.date] || {};
      current['day'] = item.date;
      current[item.project.id] = (current[item.project.id] || 0) + item.hours;
      current['date'] = dayjs(item.date).format('DD');
      resultData.push(current);
      resultItem[item.date] = current;
    });
  }

  const dataFilter = uniqWith(resultData.reverse(), isEqual);
  return createListArrayDate(timeStart, timeEnd, dataFilter);
};
